import LightTable from "@/components/Tables/LightTable";

<template>
  <v-app>
    <v-container>
      <v-app-bar dark color="primary" class="bar">
        <v-toolbar-title>{{ $t("settingsAdminForm.adminDB") }}</v-toolbar-title>
      </v-app-bar>
       <v-btn color="secondary" class="mt-5" @click="restartService">
          {{ $t("settingsAdminForm.restart") }}
        </v-btn>
      <v-card class="form-scroll-container mt-5 pa-5">
        <v-form ref="settingsForm" v-model="valid" @submit.prevent="saveSettings">
          <h2>{{ $t("settingsAdminForm.database") }}</h2>
          <v-row>
            <v-col cols="12" md="6">
              <h3 class="mb-5">{{ $t("settingsAdminForm.debugConnections") }}</h3>
              <div v-for="([key], index) in Object.entries(form.debugFields)" :key="index" class="field">
                <v-text-field :label="$t('settingsAdminForm.' + toCamelCase(key))" v-model="form.debugFields[key]" outlined></v-text-field>
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <h3 class="mb-5">{{ $t("settingsAdminForm.releaseConnections") }}</h3>
              <div v-for="([key], index) in Object.entries(form.releaseFields)" :key="index" class="field">
                <v-text-field :label="$t('settingsAdminForm.' + toCamelCase(key))" v-model="form.releaseFields[key]" outlined></v-text-field>
              </div>
            </v-col>
          </v-row>
          <h2 class="mt-5">{{ $t("settingsAdminForm.additionalSettings") }}</h2>

          <v-text-field class="mt-5" :label="$t('settingsAdminForm.embUrl')" v-model="form.embUrl" outlined></v-text-field>

          <v-text-field :label="$t('settingsAdminForm.updateFrequency')" v-model="form.updateFrequency" outlined></v-text-field>

          <v-text-field :label="$t('settingsAdminForm.countRows')" v-model="form.countRows" outlined></v-text-field>

          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group v-model="form.enableKiosks" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.enableKiosks") }}</label>
                <v-radio :label="$t('settingsAdminForm.yes')" value="true"></v-radio>
                <v-radio :label="$t('settingsAdminForm.no')" value="false"></v-radio>
              </v-radio-group>

              <v-radio-group v-model="form.enableToCancel" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.enableToCancel") }}</label>
                <v-radio :label="$t('settingsAdminForm.yes')" value="true"></v-radio>
                <v-radio :label="$t('settingsAdminForm.no')" value="false"></v-radio>
              </v-radio-group>

              <v-radio-group v-model="form.enableToFinal" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.enableToFinal") }}</label>
                <v-radio :label="$t('settingsAdminForm.yes')" value="true"></v-radio>
                <v-radio :label="$t('settingsAdminForm.no')" value="false"></v-radio>
              </v-radio-group>

              <v-radio-group v-model="form.enableToCentral" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.enableToCentral") }}</label>
                <v-radio :label="$t('settingsAdminForm.yes')" value="true"></v-radio>
                <v-radio :label="$t('settingsAdminForm.no')" value="false"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6">
              <v-radio-group v-model="form.enableReports" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.enableReports") }}</label>
                <v-radio :label="$t('settingsAdminForm.yes')" value="true"></v-radio>
                <v-radio :label="$t('settingsAdminForm.no')" value="false"></v-radio>
              </v-radio-group>

              <v-radio-group v-model="form.displayLogs" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.displayLogs") }}</label>
                <v-radio :label="$t('settingsAdminForm.yes')" value="true"></v-radio>
                <v-radio :label="$t('settingsAdminForm.no')" value="false"></v-radio>
              </v-radio-group>

              <v-radio-group v-model="form.defaultDarkTheme" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.defaultDarkTheme") }}</label>
                <v-radio :label="form.defaultDarkTheme ? $t('settingsAdminForm.dark') : $t('settingsAdminForm.light')" value="true"></v-radio>
                <v-radio :label="form.defaultDarkTheme ? $t('settingsAdminForm.light') : $t('settingsAdminForm.dark')" value="false"></v-radio>
              </v-radio-group>

              <v-radio-group v-model="form.defaultLang" row>
                <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.defaultLang") }}</label>
                <v-radio :label="$t('settingsAdminForm.english')" value="en"></v-radio>
                <v-radio :label="$t('settingsAdminForm.russian')" value="ru"></v-radio>
              </v-radio-group>
            </v-col>
              
            <v-radio-group class="ml-3 mt-0" v-model="form.enableToCentralPrint" row >
              <label class="subtitle-1 mr-3">{{ $t("settingsAdminForm.enableToCentralPrint") }}</label>
              <v-radio :label="$t('settingsAdminForm.yes')" value="true"></v-radio>
              <v-radio :label="$t('settingsAdminForm.no')" value="false"></v-radio>
            </v-radio-group>
          </v-row>

          <v-text-field class="mt-5" :label="$t('settingsAdminForm.bankTitle')" v-model="form.bankTitle" outlined></v-text-field>

          <v-text-field :label="$t('settingsAdminForm.bankIcon')" v-model="form.bankIcon" outlined></v-text-field>

          <v-text-field :label="$t('settingsAdminForm.statusesToCentral')" v-model="form.statusesToCentral" outlined></v-text-field>

          <v-combobox
            v-model="form.selectedRightToReport"
            :items="rights"
            item-value="id"
            :label="$t('settingsAdminForm.rightToReport')"
            outlined
          >
            <template v-slot:item="data">{{ $t(`settingsAdminForm.rights.${data.item.id}`) }}</template>
            <template v-slot:selection="data">{{ $t(`settingsAdminForm.rights.${data.item.id}`) }}</template>
          </v-combobox>

      <h2 class="mt-5">{{ $t("settingsAdminForm.license") }}</h2>
        <v-text-field class="mt-5" :label="$t('settingsAdminForm.certificate')" v-model="form.license" outlined></v-text-field>

        <v-btn type="submit" color="primary" :disabled="!valid" class="mt-3">
          {{ $t("settingsAdminForm.save") }}
        </v-btn>

      </v-form>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { defineComponent, ref, reactive, computed, onMounted, getCurrentInstance } from 'vue';
import { notifyError, notifySuccess } from '../services/notifications';

export default defineComponent({
  name: 'SettingsAdminForm',
  setup() {
    const { proxy } = getCurrentInstance();

    const valid = ref(false);
    const rights = ref([]);
    const form = reactive({
      debugFields: {},
      releaseFields: {},
      provider: '',
      connString: '',
      commandTimeout: '',
      maxPoolSize: '',
      minPoolSize: '',
      embUrl: '',
      updateFrequency: '',
      countRows: '', 
      enableKiosks: null,
      enableToCancel: null,
      enableToFinal: null,
      enableToCentral: null,
      enableReports: null,
      defaultDarkTheme: null,
      defaultLang: null,
      displayLogs: null,
      bankTitle: '',
      bankIcon: '',
      enableToCentralPrint: null,
      enablePasswordEncryption: null,
      statusesToCentral: '',
      needAdminToCancel: null,
      selectedRightToReport: null,
      license: '',
    });

    const adminSettings = computed(() => proxy.$store.state.adminSettings);

    const loadSettings = async () => {
      const data = adminSettings.value;
      if (!data || !data.Settings) {
        return;
      }

      const connDebug = data.ConnectionStrings?.DebugConnection;
      const connRelease = data.ConnectionStrings?.ReleaseConnection;
      const connSingle = data.DataBaseSettings?.ConnectionString;
      if (connDebug && connRelease) {
        form.debugFields = parseConnString(connDebug);
        form.releaseFields = parseConnString(connRelease);
      } else if (connSingle) {
        const parsed = parseConnString(connSingle);
        form.debugFields = { ...parsed };
        form.releaseFields = { ...parsed };
      } else if (connDebug) {
        form.debugFields = parseConnString(connDebug);
        form.releaseFields = {};
      } else {
        form.debugFields = {};
        form.releaseFields = {};
      }

      form.embUrl = data.Settings.Emb_Url || '';
      form.updateFrequency = data.Settings.Update_Frequency || '';
      form.countRows = data.Settings.Count_Rows || '';
      form.enableKiosks = data.Settings.Enable_Kiosks;
      form.enableToCancel = data.Settings.Enable_To_Cancel;
      form.enableToFinal = data.Settings.Enable_To_Final;
      form.enableToCentral = data.Settings.Enable_To_Central;
      form.enableReports = data.Settings.Enable_Reports;
      form.defaultDarkTheme = data.Settings.Default_Dark_Theme;
      form.defaultLang = data.Settings.Default_Lang;
      form.displayLogs = data.Settings.Display_Logs;
      form.bankTitle = data.Settings.Bank_Title || '';
      form.bankIcon = data.Settings.Bank_Icon || '';
      form.enableToCentralPrint = data.Settings.Enable_To_Central_Print;
      form.enablePasswordEncryption =
        (data.DataBaseSettings && data.DataBaseSettings.EnablePasswordEncryption) ??
        data.Settings.EnablePasswordEncryption;
      form.statusesToCentral = data.Settings.StatusesToCentral || '';
      form.needAdminToCancel = data.Settings.NeedAdminToCancel;

      const rightToReport = rights.value.find(item => item.id == data.Settings.RightToReport);
      form.selectedRightToReport = rightToReport || null;

      form.license = (data.TrustCert && data.TrustCert.Name) || '';
    };

    const loadRights = async () => {
      try {
        const response = await proxy.$axios.rights.getByRoleId(1, {});
        rights.value = response.data.map(item => ({
          id: item.rightId,
          name: proxy.$t(`settingsAdminForm.rights.${item.rightId}`)
        }));
      } catch (error) {
        console.error('Ошибка загрузки прав', error);
      }
    };

    const saveSettings = async () => {
      if (!form.selectedRightToReport) {
        notifyError('', proxy.$t('settingsAdminForm.selectRightToReport'));
        
        return;
      }

      const prev =
        adminSettings.value && typeof adminSettings.value === 'object'
          ? JSON.parse(JSON.stringify(adminSettings.value))
          : {};

      const releaseCs = buildConnString(form.releaseFields || {});
      const payload = {
        ...prev,
        ConnectionStrings: {
          ...(prev.ConnectionStrings || {}),
          DebugConnection: buildConnString(form.debugFields || {}),
          ReleaseConnection: releaseCs,
        },
        Settings: {
          ...(prev.Settings || {}),
          Emb_Url: form.embUrl || '',
          Update_Frequency: form.updateFrequency || '',
          Count_Rows: form.countRows || '',
          Enable_Kiosks: form.enableKiosks,
          Enable_To_Cancel: form.enableToCancel,
          Enable_To_Final: form.enableToFinal,
          Enable_To_Central: form.enableToCentral,
          Enable_Reports: form.enableReports,
          Default_Dark_Theme: form.defaultDarkTheme,
          Default_Lang: form.defaultLang,
          Display_Logs: form.displayLogs,
          Bank_Title: form.bankTitle || '',
          Bank_Icon: form.bankIcon || '',
          Enable_To_Central_Print: form.enableToCentralPrint,
          StatusesToCentral: form.statusesToCentral || '',
          NeedAdminToCancel: form.needAdminToCancel,
          RightToReport: form.selectedRightToReport.id,
        },
        TrustCert: {
          ...(prev.TrustCert || {}),
          Name: form.license || '',
        },
        DataBaseSettings: {
          ...(prev.DataBaseSettings || {}),
          EnablePasswordEncryption: form.enablePasswordEncryption,
          ...(releaseCs ? { ConnectionString: releaseCs } : {}),
        },
      };
      delete payload.Settings.EnablePasswordEncryption;
      try {
        const response = await proxy.$axios.adminSettings.saveAdminSettings(payload);
        proxy.$store.commit('setAdminSettings', response.data);
        notifySuccess('', proxy.$t('settingsAdminForm.saveSettingsSuccess'));
      } catch (error) {
        console.error('Error saving settings:', error);
        notifyError('', proxy.$t('settingsAdminForm.updateSettingsError'));
      }
    };

    const restartService = async () => {
      try {
        await proxy.$axios.adminSettings.restart();
        notifySuccess('', proxy.$t('settingsAdminForm.restartSuccess'));
      } catch (error) {
        notifyError('', proxy.$t('settingsAdminForm.restartError'));
      }
    };

    const toCamelCase = (str) => {
      return str
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
    };

    onMounted(async () => {
      try {
        await loadRights();
        await loadSettings();
      } catch (error) {
        console.error('Error initializing component:', error);
      }
    });

    return {
      valid,
      rights,
      form,
      adminSettings,
      loadSettings,
      loadRights,
      saveSettings,
      restartService,
      toCamelCase,
      Object,
    };
  },
  // при покидании страницы очищаем пароль из стора
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setAdminPassword', ''); 
    next();
  }
});

function parseConnString(string) {
  const arr = string.split(';');
  const obj = {};

  for (const str of arr) {
    if (!str) continue;
    const [key, value] = str.split('=');
    obj[key] = value;
  }

  return obj;
}

function buildConnString(fields) {
  return Object.entries(fields)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');
}
</script>

<style scoped>
  .mt-3 {
    margin-top: 1rem;
  }

  .mt-0 {
    margin-top: 0;
  }

  .mt-5 {
    margin-top: 3rem;
  }

  .pa-5 {
    padding: 3rem;
  }

  .v-application {
    width: 100%;
  }

  .bar {
    display: flex;
  }

  .form-scroll-container {
    max-height: 500px; /* или нужное значение */
    overflow-y: auto;
  }
</style>